export default class FileTooLargeError {}



// WEBPACK FOOTER //
// ./src/common/domain/FileTooLargeError.js